import { useState, useRef, useEffect } from 'react';

const KEYBOARD_SHORTCUT = 'k';

export const useSearchModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleGlobalKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === KEYBOARD_SHORTCUT) {
        event.preventDefault();
        setIsOpen(true);
      }
    };

    document.addEventListener('keydown', handleGlobalKeyDown);

    if (isOpen) {
      inputRef.current?.focus();
    }

    return () => {
      document.removeEventListener('keydown', handleGlobalKeyDown);
    };
  }, [isOpen]);

  return { isOpen, setIsOpen, inputRef };
};
